<template>
<div>
  <Grid name="filterGridCore" ref="filterGridCore" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'Core',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'cores',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      },
      {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    addIncludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'includes'
      })
    },
    addExpurgeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'expurges'
      })
    },
    addExcludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'excludes'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CoreFilter.vue?26fa4798